import DServiceProviderDetailPage from './DServiceProviderDetailPage'

export default DServiceProviderDetailPage
